var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export function isWixProduct(product) {
    return window.zakeke.catalogVersion === "V1_CATALOG";
}
export function isWixProductV3(product) {
    return window.zakeke.catalogVersion === "V3_CATALOG";
}
export function getTranslations() {
    const languages = {
        af: {
            AddToCart: 'Voeg by mandjie',
            Customize: 'pas'
        },
        am: {
            AddToCart: 'ወደ ግዢው ቅርጫት ጨምር',
            Customize: 'ብጁ አድርግ'
        },
        ar: {
            AddToCart: 'أضِف إلى العربة',
            Customize: 'يعدل أو يكيف'
        },
        az: {
            AddToCart: 'Səbətə əlavə et',
            Customize: 'Özəlləşdirmək'
        },
        bg: {
            AddToCart: 'Добави в кошницата',
            Customize: 'Персонализирайте'
        },
        bn: {
            AddToCart: 'কার্টে যোগ করুন',
            Customize: 'কাস্টমাইজ করুন'
        },
        bs: {
            AddToCart: 'Dodaj v voziček',
            Customize: 'Prilagodite'
        },
        ca: {
            AddToCart: 'Afegeix al carretó',
            Customize: 'Personalitza'
        },
        co: {
            AddToCart: 'Add to cart',
            Customize: 'Customize'
        },
        cs: {
            AddToCart: 'Přidat do košíku',
            Customize: 'Přizpůsobte'
        },
        cy: {
            AddToCart: 'Ychwanegu at y drol',
            Customize: 'Addasu'
        },
        da: {
            AddToCart: 'Tilføj til kurv',
            Customize: 'Tilpas'
        },
        de: {
            AddToCart: 'In den Warenkorb',
            Customize: 'Anpassen',
            'Out of Stock': 'Nicht vorrätig'
        },
        el: {
            AddToCart: 'Προσθήκη στο καλάθι',
            Customize: 'Προσαρμογή'
        },
        en: {
            AddToCart: 'Add to cart',
            Customize: 'Customize',
            'Out of Stock': 'Out of Stock'
        },
        es: {
            AddToCart: 'Agregar al carrito',
            Customize: 'Personaliza'
        },
        et: {
            AddToCart: 'Lisa ostukorvi',
            Customize: 'Kohanda'
        },
        eu: {
            AddToCart: 'Saskira gehitu',
            Customize: 'Pertsonalizatu'
        },
        fi: {
            AddToCart: 'Lisää ostoskoriin',
            Customize: 'muokata'
        },
        fr: {
            AddToCart: 'Ajouter au panier',
            Customize: 'Personnaliser',
            'Out of Stock': 'En rupture de stock'
        },
        gl: {
            AddToCart: 'Engadir ao carro',
            Customize: 'Personalizar'
        },
        gu: {
            AddToCart: 'કસ્ટમાઇઝ કરો',
            Customize: 'કસ્ટમાઇઝ કરો'
        },
        ha: {
            AddToCart: 'Ƙara',
            Customize: 'Musanya'
        },
        he: {
            AddToCart: 'הוספה לסל',
            Customize: 'התאמה אישית'
        },
        hi: {
            AddToCart: 'कार्ट में जोड़ें',
            Customize: 'अनुकूलित करें'
        },
        hr: {
            AddToCart: 'Dodaj u košaricu',
            Customize: 'Prilagođavanje'
        },
        hu: {
            AddToCart: 'Kosárba tesz',
            Customize: 'szabása'
        },
        hy: {
            AddToCart: 'Ավելացնել զամբյուղի',
            Customize: 'Անհատականացրեք'
        },
        id: {
            AddToCart: 'Tambahkan ke keranjang',
            Customize: 'Sesuaikan'
        },
        is: {
            AddToCart: 'Setja í körfu',
            Customize: 'Sérsníða'
        },
        it: {
            AddToCart: 'Aggiungi al carrello',
            Customize: 'Personalizza'
        },
        ja: {
            AddToCart: 'カートに追加',
            Customize: 'カスタマイズ'
        },
        jv: {
            AddToCart: 'Tambah menyang keranjang',
            Customize: 'Ngatur'
        },
        ka: {
            AddToCart: 'დამატება კალათაში',
            Customize: 'მორგება'
        },
        kk: {
            AddToCart: 'Добавить в корзину',
            Customize: 'Теңшеу'
        },
        km: {
            AddToCart: 'បន្ថែមទៅរទេះ',
            Customize: 'ប្ដូរតាមបំណង'
        },
        kn: {
            AddToCart: 'ಕಾರ್ಟ್ಗೆ ಸೇರಿಸು',
            Customize: 'ಕಸ್ಟಮೈಸ್ ಮಾಡಿ'
        },
        ko: {
            AddToCart: '장바구니에 추가',
            Customize: '사용자 정의'
        },
        lb: {
            AddToCart: 'Add to cart',
            Customize: 'Customize'
        },
        lo: {
            AddToCart: 'ຕື່ມໃສ່ຕະກ້າ',
            Customize: 'ປັບແຕ່ງ'
        },
        lt: {
            AddToCart: 'Įdėti į krepšelį',
            Customize: 'Pritaikyti'
        },
        lv: {
            AddToCart: 'Pievienot grozam',
            Customize: 'Pielāgot'
        },
        mg: {
            AddToCart: "Ampio amin'ny cart",
            Customize: 'Ataovy miavaka'
        },
        mk: {
            AddToCart: 'Додај во кошничка',
            Customize: 'Прилагоди'
        },
        ml: {
            AddToCart: 'കാർഡിലേക്ക് ചേർക്കുക',
            Customize: 'ഇഷ്ടാനുസൃതമാക്കുക'
        },
        mn: {
            AddToCart: 'Өөртөө сагсанд нэмэх',
            Customize: 'Тохируулах'
        },
        mr: {
            AddToCart: 'कार्टमध्ये जोडा',
            Customize: 'सानुकूल करा'
        },
        ms: {
            AddToCart: 'Tambah ke troli',
            Customize: 'Peribadikan'
        },
        ne: {
            AddToCart: 'कार्टमा थप्नुहोस्',
            Customize: 'अनुकूलन गर्नुहोस्'
        },
        nl: {
            AddToCart: 'Voeg toe aan Winkelwagetje',
            Customize: 'Aanpassen',
            'Out of Stock': 'Geen voorraad meer'
        },
        nb: {
            AddToCart: 'Legg i handlevogn',
            Customize: 'Tilpass'
        },
        no: {
            AddToCart: 'Legg til i handlekurv',
            Customize: 'Tilpass'
        },
        pa: {
            AddToCart: 'ਕਾਰਟ ਸ਼ਾਮਲ ਕਰੋ',
            Customize: 'ਕਸਟਮਾਈਜ਼ ਕਰੋ'
        },
        pl: {
            AddToCart: 'Dodaj do koszyka',
            Customize: 'Dostosuj'
        },
        ps: {
            AddToCart: 'د کارت کې شامل کړئ',
            Customize: 'دودیز کول'
        },
        pt: {
            AddToCart: 'Adicionar ao carrinho',
            Customize: 'Customizar'
        },
        ro: {
            AddToCart: 'Adăugați în coș',
            Customize: 'Personalizați'
        },
        ru: {
            AddToCart: 'Добавить в корзину',
            Customize: 'Настроить'
        },
        si: {
            AddToCart: 'අභිරුචිකරණය',
            Customize: 'අභිමතකරණය කරන්න'
        },
        sk: {
            AddToCart: 'Pridať do košíka',
            Customize: 'prispôsobenie'
        },
        sl: {
            AddToCart: 'Dodaj v voziček',
            Customize: 'Prilagoditi'
        },
        so: {
            AddToCart: 'Add to cart',
            Customize: 'Kala habee'
        },
        sq: {
            AddToCart: 'Shto në shportë',
            Customize: 'Customize'
        },
        sr: {
            AddToCart: 'Додај у колица',
            Customize: 'Прилагоди'
        },
        su: {
            AddToCart: 'Tambahkeun kana karanjang',
            Customize: 'ngaropea'
        },
        sv: {
            AddToCart: 'Lägg till i kundvagnen',
            Customize: 'Anpassa'
        },
        sw: {
            AddToCart: 'Ongeza kwenye gari',
            Customize: 'Customize'
        },
        ta: {
            AddToCart: 'வண்டிக்குச் சேர்',
            Customize: 'தனிப்பயனாக்கலாம்'
        },
        tg: {
            AddToCart: 'Ба тамғаи',
            Customize: 'Customize'
        },
        tr: {
            AddToCart: 'Sepete Ekle',
            Customize: 'Özelleştirmek'
        },
        uk: {
            AddToCart: 'Додати в кошик',
            Customize: 'Налаштувати'
        },
        ur: {
            AddToCart: 'ٹوکری میں شامل کریں',
            Customize: 'حسب ضرورت'
        },
        uz: {
            AddToCart: "Savatchaga qo'shish",
            Customize: 'Moslashtiring'
        },
        vi: {
            AddToCart: 'Thêm vào giỏ hàng',
            Customize: 'Tùy chỉnh'
        },
        yi: {
            AddToCart: 'לייג צו צום וואגען',
            Customize: 'Customize'
        },
        zh: {
            AddToCart: '新增到購物車中',
            Customize: '定制'
        }
    };
    let l = (window.wixEmbedsAPI && window.wixEmbedsAPI.getLanguage()) || 'en';
    if (l && l.indexOf('-') > 0) {
        l = l.split('-')[0];
    }
    else if (!l) {
        l = 'en';
    }
    return languages[l];
}
export function getTranslatedAddToCart() {
    return getTranslations() ? getTranslations()['AddToCart'] : 'Add to Cart';
}
export function ensureAddToCartButtonOrCustomizeDisplayed() {
    return __awaiter(this, void 0, void 0, function* () {
        const translatedAddToCart = getTranslatedAddToCart();
        const isPresent = () => document.querySelector('button[aria-label^="' + translatedAddToCart + '" i]') ||
            document.querySelector('button[data-hook="add-to-cart"]') ||
            getMerchantCustomizeButton();
        if (isPresent())
            return;
        let checkForAddToCartOrCustomizeButtonInterval = null;
        const promise = new Promise((resolve, reject) => {
            let checkCount = 0;
            checkForAddToCartOrCustomizeButtonInterval = setInterval(() => {
                if (checkCount == 10)
                    reject();
                console.log("[ZKK] checkForAddToCartOrCustomizeButtonInterval ", isPresent());
                if (isPresent()) {
                    resolve(true);
                }
                checkCount++;
            }, 500);
        });
        try {
            yield Promise.all([promise]);
        }
        catch (err) {
            console.error("[ZKK] Add to cart button not found");
            throw err;
        }
        finally {
            clearInterval(checkForAddToCartOrCustomizeButtonInterval);
        }
    });
}
export function hideMerchantCustomizeButton() {
    let wixCustomElement = getMerchantCustomizeButton();
    if (wixCustomElement) {
        wixCustomElement.style.display = 'none';
    }
}
const WIX_HEADER_SELECTORS = 'header, nav, [role="banner"], [role="navigation"], #SITE_HEADER, [data-testid="SITE_HEADER"]';
export function getMerchantCustomizeButton() {
    var _a;
    const candidates = Array.from(document.querySelectorAll('button[aria-label="Customize" i]'));
    const productScoped = candidates.filter((btn) => !btn.closest(WIX_HEADER_SELECTORS));
    return (_a = productScoped[0]) !== null && _a !== void 0 ? _a : null;
}
export function getAddToCartButton(isWixNewProductPage) {
    var _a;
    if (isWixNewProductPage === void 0) { isWixNewProductPage = (_a = window.zakeke) === null || _a === void 0 ? void 0 : _a.isWixNewProductPage; }
    if (isWixNewProductPage) {
        return document.querySelector('button[aria-label^="' + getTranslatedAddToCart() + '" i]');
    }
    else {
        return document.querySelector('button[data-hook="add-to-cart"]');
    }
}
export function getParentAddToCartButton(isWixNewProductPage) {
    var _a;
    if (isWixNewProductPage === void 0) { isWixNewProductPage = (_a = window.zakeke) === null || _a === void 0 ? void 0 : _a.isWixNewProductPage; }
    const addToCartButton = getAddToCartButton(isWixNewProductPage);
    return addToCartButton === null || addToCartButton === void 0 ? void 0 : addToCartButton.parentNode;
}
export function getBuyNowButton(isWixNewProductPage) {
    var _a;
    if (isWixNewProductPage === void 0) { isWixNewProductPage = (_a = window.zakeke) === null || _a === void 0 ? void 0 : _a.isWixNewProductPage; }
    if (isWixNewProductPage) {
        return document.querySelector('button[aria-label^="Buy Now" i]');
    }
    else {
        return document.querySelector('button[data-hook="buy-now-button"]');
    }
}
export function getParentBuyNowButton(isWixNewProductPage) {
    var _a;
    if (isWixNewProductPage === void 0) { isWixNewProductPage = (_a = window.zakeke) === null || _a === void 0 ? void 0 : _a.isWixNewProductPage; }
    const buyNowButton = getBuyNowButton(isWixNewProductPage);
    return buyNowButton === null || buyNowButton === void 0 ? void 0 : buyNowButton.parentNode;
}
export function getIframe() {
    return document.querySelector('#zakeke-frame');
}
export function getBackground() {
    return document.querySelector('#zakeke-background');
}
export function getContainer() {
    return document.querySelector('#zakeke-container');
}
export function isLargeVersion() {
    return window.matchMedia('(min-width: 769px)').matches;
}
export function getStore() {
    const url = document.querySelector('script[id="zakeke-customizer"]').src;
    const urlParams = new URLSearchParams(url.split('?')[1]);
    return urlParams.get('store');
}
export function loadCss(zakekeInstance) {
    const link = document.createElement('LINK');
    link.href = zakekeInstance + '/Content/css/integration/Wix/customizer.css?v2';
    link.type = 'text/css';
    link.rel = 'stylesheet';
    link.media = 'screen,print';
    document.getElementsByTagName('head')[0].appendChild(link);
}
export function removeIframeElement() {
    var _a, _b, _c;
    const iframe = getIframe();
    const background = getBackground();
    const container = getContainer();
    document.body.style.overflow = 'initial';
    (_a = iframe === null || iframe === void 0 ? void 0 : iframe.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(iframe);
    (_b = container === null || container === void 0 ? void 0 : container.parentNode) === null || _b === void 0 ? void 0 : _b.removeChild(container);
    (_c = background === null || background === void 0 ? void 0 : background.parentNode) === null || _c === void 0 ? void 0 : _c.removeChild(background);
}
export function buildContainer() {
    const background = document.createElement('DIV');
    background.id = 'zakeke-background';
    document.body.appendChild(background);
    const container = document.createElement('DIV');
    container.id = 'zakeke-container';
    const iframe = document.createElement('IFRAME');
    iframe.setAttribute('allowFullScreen', '');
    iframe.setAttribute('allow', 'clipboard-write; web-share; microphone');
    iframe.id = 'zakeke-frame';
    iframe.style.display = 'none';
    container.appendChild(iframe);
    const close = document.createElement('A');
    close.id = 'zakeke-container-close';
    const closeTextElement = document.createElement('SPAN');
    closeTextElement.innerText = 'Close customizer';
    close.appendChild(closeTextElement);
    const closeMobile = document.createElement('DIV');
    closeMobile.id = 'zakeke-container-close-mobile';
    const closeOver = document.createElement('DIV');
    closeOver.id = 'zakeke-close-over';
    const closeFunc = () => {
        if (!confirm('All your unsaved changes will be lost. Proceed?')) {
            return;
        }
        removeIframeElement();
    };
    close.addEventListener('click', () => {
        closeFunc();
    });
    closeMobile.addEventListener('click', () => {
        closeFunc();
    });
    closeOver.addEventListener('click', () => {
        closeFunc();
    });
    if (isLargeVersion()) {
        container.appendChild(close);
        container.appendChild(closeOver);
    }
    else {
        container.appendChild(closeMobile);
    }
    background.appendChild(container);
    document.body.appendChild(background);
}
export function removeContainer() {
    let container = document.getElementById('zakeke-background');
    if (container) {
        document.body.removeChild(container);
    }
}
